module.exports = __webpack_public_path__ + "static/media/person-nick-socci.e1970ed3.png";